import { render, staticRenderFns } from "./Inscripcionrestx-add.vue?vue&type=template&id=2ab9764c"
import script from "./Inscripcionrestx-add.vue?vue&type=script&lang=js"
export * from "./Inscripcionrestx-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports